import React, { useCallback, useEffect, useRef, useState } from 'react';
import api from '../../services/api';
import TravelPromptModal from './TravelPromptModal';

/**
 * Nhúng MỘT lần trong khung ứng dụng (Layout): tự hiện hộp thoại "ăn cơm thế nào?" khi nhân viên vừa chấm công ở nơi khác nơi
 * làm việc — ở bất kỳ trang nào, kể cả ngay sau khi bấm chấm công.
 *
 * An toàn cho bản chưa có tính năng: trước hết đọc GET /meals/access (luôn có); chỉ khi backend báo features.travel mới bắt đầu
 * hỏi câu hỏi — nên máy chủ cũ không bị gọi vào đường dẫn chưa tồn tại (tránh 404 nhật ký lỗi hàng loạt).
 * Làm mới: lúc vào, mỗi 3 phút, khi quay lại tab, và khi trang chấm công phát sự kiện 'meal:check'.
 */
export default function MealTravelPromptHost() {
  const [prompt, setPrompt] = useState(null);
  const enabled = useRef(null); // null = chưa biết
  const dismissed = useRef(new Set());
  const busy = useRef(false);

  const check = useCallback(async () => {
    if (busy.current || enabled.current === false || document.hidden) return;
    busy.current = true;
    try {
      if (enabled.current === null) {
        const a = await api.get('/meals/access');
        enabled.current = !!a.data?.data?.features?.travel && !!a.data?.data?.can_register;
        if (!enabled.current) return;
      }
      const r = await api.get('/meals/travel/prompts/mine');
      const pending = (r.data?.data?.prompts || []).filter((p) => p.status === 'pending' && !dismissed.current.has(p.prompt_id));
      setPrompt((cur) => (cur && pending.some((p) => p.prompt_id === cur.prompt_id) ? cur : (pending[0] || null)));
    } catch (e) {
      if ([401, 403, 404].includes(e?.response?.status)) enabled.current = false; // không có quyền / chưa có tính năng: thôi
    } finally { busy.current = false; }
  }, []);

  useEffect(() => {
    const first = setTimeout(check, 4000);
    const timer = setInterval(check, 3 * 60 * 1000);
    const onVisible = () => { if (!document.hidden) check(); };
    const onEvent = () => setTimeout(check, 1500);
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('meal:check', onEvent);
    return () => { clearTimeout(first); clearInterval(timer); document.removeEventListener('visibilitychange', onVisible); window.removeEventListener('meal:check', onEvent); };
  }, [check]);

  if (!prompt) return null;
  return (
    <TravelPromptModal
      prompt={prompt}
      onClose={() => { dismissed.current.add(prompt.prompt_id); setPrompt(null); }}
      onAnswered={() => { dismissed.current.add(prompt.prompt_id); setTimeout(check, 500); }}
    />
  );
}
